import Input from "./Input.jsx";
import Password from "./Password.jsx";
import Link from "./Link.jsx";
import Rating from "./Rating.jsx";
import RadioGroup from "./RadioGroup.jsx";
import Select from "./Select.jsx";
import Checkbox from "./Checkbox.jsx";
import DatePicker from "./DatePicker.jsx";
import Button from "./Button.jsx";
import SliderInput from "./SliderInput.jsx";
import TwoLabelSlider from "./TwoLabelSlider.jsx";
import Switch from "./Switch.jsx";
import AutoComplete from "./AutoComplete.jsx";
import Textarea from "./Textarea.jsx";
import Upload from "./Upload.jsx";
import DetailedRadioGroup from "./DetailedRadioGroup.jsx";
import Accordion from "./Accordion.jsx";
import Expandable from "./Expandable.jsx";
import Stepper from "./Stepper.jsx";
import StepperV2 from "./StepperV2.jsx";
import JourneyWizard from "./JourneyWizard.jsx";
import PhaseRail from "./PhaseRail.jsx";
import SelectList from "./SelectList.jsx";
import Info from "./Info.jsx";
import ButtonGroup from "./ButtonGroup.jsx";
import TimePicker from "./TimePicker.jsx";
import NumberInput from "./NumberInput.jsx";
import SumInput from "./SumInput.jsx";
import FillButton from "./FillButton.jsx";
import EMailInput from "./EMailInput.jsx";
import SBWarning from "./SBWarning.jsx";
import SegmentedInput from "./SegmentedInput.jsx";
import ChipToggle from "./ChipToggle.jsx";

const Controls = {
  Input,
  Password,
  Link,
  RadioGroup,
  Select,
  Checkbox,
  DatePicker,
  Button,
  Rating,
  SliderInput,
  TwoLabelSlider,
  Switch,
  AutoComplete,
  Textarea,
  Upload,
  DetailedRadioGroup,
  Accordion,
  Expandable,
  Stepper,
  StepperV2,
  JourneyWizard,
  PhaseRail,
  SelectList,
  Info,
  ButtonGroup,
  TimePicker,
  NumberInput,
  SumInput,
  FillButton,
  EMailInput,
  SBWarning,
  SegmentedInput,
  ChipToggle,
};

export default Controls;
